import { Connectivity_getInstance33ghnmuved25k as Connectivity_getInstance } from './fetch-connectivity.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { clockMillis2lf7cl1xsmoff as clockMillis } from './clockMillis.mjs';
import {
  intercepted2ogpsikxxj4u0 as intercepted,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
} from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ConnectionException1wjs7wwnknnfm as ConnectionException } from './fetch.mjs';
import {
  Companion_instance2oawqq9qiaris as Companion_instance,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { returnIfSuspendedqak8u4r448cu as returnIfSuspended } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coroutineInternalJS.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  multiply2k9eolhnz1bjv as multiply,
  toNumber2e2hj9zugjwi2 as toNumber,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { printStackTrace214c8iyv3cpiv5 as printStackTrace2 } from './debugger.js.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { take9j4462mea726 as take } from '../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { report1vfr9zf0i9d9p as report } from './debugger.mjs';
import { delayolwo40i9ucjz as delay } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function retryWebsocket(underlyingSocket, pingTime, gate, log) {
  gate = gate === VOID ? Connectivity_getInstance().ncw_1 : gate;
  log = log === VOID ? null : log;
  if (log == null)
    null;
  else {
    log.fcv(['Creating']);
  }
  var baseDelay = 1000n;
  var currentDelay = {_v: baseDelay};
  var lastConnect = {_v: 0.0};
  // Inline function 'kotlin.also' call
  var this_0 = Signal().fak(false);
  var it = this_0;
  it.tah(() => {
    var tmp0_safe_receiver = log;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.fcv(['connected: ' + it.f2()]);
    }
    return Unit_instance;
  });
  var connected = this_0;
  var currentWebSocket = {_v: null};
  var onOpenList = ArrayList().w();
  var onMessageList = ArrayList().w();
  var onBinaryMessageList = ArrayList().w();
  var onCloseList = ArrayList().w();
  var lastPong = {_v: clockMillis()};
  var instanceCount = {_v: 0};
  var currentWebSocketId = {_v: -1};
  return new (retryWebsocket$1())(connected, currentWebSocket, gate, log, instanceCount, currentWebSocketId, underlyingSocket, onOpenList, lastPong, onMessageList, onBinaryMessageList, onCloseList, lastConnect, pingTime, currentDelay, baseDelay);
}
function typed(_this__u8e3s4, json, send, receive) {
  return new (typed$1())(_this__u8e3s4, json, receive, send);
}
function *_generator_waitUntilConnect__yuyg0p(_this__u8e3s4, delay, $completion) {
  var tmp;
  if (delay === VOID) {
    tmp = waitUntilConnect$slambda_0();
  } else {
    tmp = delay;
  }
  delay = tmp;
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
  cancellable.ra5();
  var it = cancellable;
  var alreadyResumed = {_v: false};
  _this__u8e3s4.rdl(() => {
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, waitUntilConnect$lambda$slambda_0(delay, alreadyResumed, it));
    return Unit_instance;
  });
  _this__u8e3s4.sdl((code) => {
    var tmp;
    if (!alreadyResumed._v) {
      alreadyResumed._v = true;
      var tmp0 = it;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = ConnectionException().mcx('Socket closed almost immediately.  Code ' + code);
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      tmp0.rc(tmp$ret$0);
      tmp = Unit_instance;
    }
    return Unit_instance;
  });
  var tmp$ret$3 = cancellable.sa5();
  var tmp_0 = returnIfSuspended(tmp$ret$3, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function waitUntilConnect(_this__u8e3s4, delay, $completion) {
  var tmp;
  if (delay === VOID) {
    tmp = waitUntilConnect$slambda_0();
  } else {
    tmp = delay;
  }
  delay = tmp;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_waitUntilConnect__yuyg0p.bind(VOID, _this__u8e3s4, delay), $completion);
}
function *_generator_retryWebsocket$reset__delhya(instanceCount, currentWebSocketId, currentWebSocket, $underlyingSocket, $log, onOpenList, lastPong, onMessageList, onBinaryMessageList, onCloseList, lastConnect, connected, $pingTime, currentDelay, baseDelay, $completion) {
  var _unary__edvuaz = instanceCount._v;
  instanceCount._v = _unary__edvuaz + 1 | 0;
  var id = _unary__edvuaz;
  currentWebSocketId._v = id;
  var tmp = $underlyingSocket($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.also' call
  var this_0 = tmp;
  var socket = this_0;
  var pings = {_v: null};
  socket.rdl(() => {
    var tmp0_safe_receiver = $log;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.fcv(['' + id + ' onOpen']);
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = toList(onOpenList).m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      element();
    }
    return Unit_instance;
  });
  socket.tdl((it) => {
    var tmp0_safe_receiver = $log;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.fcv(['' + id + ' onMessage ' + it]);
    }
    lastPong._v = clockMillis();
    var tmp;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(it)) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = toList(onMessageList).m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        element(it);
      }
      tmp = Unit_instance;
    }
    return Unit_instance;
  });
  socket.udl((it) => {
    var tmp0_safe_receiver = $log;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.fcv(['' + id + ' onBinaryMessage ' + toString(it)]);
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = toList(onBinaryMessageList).m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      element(it);
    }
    return Unit_instance;
  });
  socket.sdl((it) => {
    var tmp0_safe_receiver = $log;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.fcv(['' + id + ' onClose ' + it]);
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = toList(onCloseList).m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      element(it);
    }
    return Unit_instance;
  });
  socket.rdl(() => {
    lastConnect._v = clockMillis();
    lastPong._v = lastConnect._v;
    connected.mam(true);
    var tmp0_safe_receiver = pings._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ma3();
    }
    var tmp = get_AppScope();
    pings._v = launch(tmp, VOID, VOID, retryWebsocket$reset$lambda$slambda_0($pingTime, lastPong, socket));
    return Unit_instance;
  });
  socket.sdl((it) => {
    var tmp0_safe_receiver = pings._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ma3();
    }
    // Inline function 'kotlin.Long.times' call
    var this_0 = currentDelay._v;
    var tmp$ret$9 = multiply(this_0, fromInt(2));
    currentDelay._v = tmp$ret$9;
    var tmp;
    var tmp_0;
    if (connected.f2()) {
      var tmp_1 = clockMillis() - lastConnect._v;
      // Inline function 'kotlin.Long.times' call
      var this_1 = $pingTime;
      var tmp$ret$10 = multiply(this_1, fromInt(2));
      tmp_0 = tmp_1 > toNumber(tmp$ret$10);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      currentDelay._v = baseDelay;
      tmp = Unit_instance;
    }
    connected.mam(false);
    return Unit_instance;
  });
  currentWebSocket._v = this_0;
  return Unit_instance;
}
function retryWebsocket$reset(instanceCount, currentWebSocketId, currentWebSocket, $underlyingSocket, $log, onOpenList, lastPong, onMessageList, onBinaryMessageList, onCloseList, lastConnect, connected, $pingTime, currentDelay, baseDelay, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_retryWebsocket$reset__delhya.bind(VOID, instanceCount, currentWebSocketId, currentWebSocket, $underlyingSocket, $log, onOpenList, lastPong, onMessageList, onBinaryMessageList, onCloseList, lastConnect, connected, $pingTime, currentDelay, baseDelay), $completion);
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp0_safe_receiver = $this.vdl_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.fcv(['starting']);
  }
  var tmp = retryWebsocket$reset($this.ydl_1, $this.zdl_1, $this.wdl_1, $this.adm_1, $this.vdl_1, $this.bdm_1, $this.cdm_1, $this.ddm_1, $this.edm_1, $this.fdm_1, $this.gdm_1, $this.hdm_1, $this.idm_1, $this.jdm_1, $this.kdm_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp1_safe_receiver = $this.wdl_1._v;
  if (tmp1_safe_receiver == null)
    null;
  else {
    var tmp_0 = waitUntilConnect(tmp1_safe_receiver, $this.xdl_1.qcw_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  var tmp2_safe_receiver = $this.vdl_1;
  var tmp_1;
  if (tmp2_safe_receiver == null) {
    tmp_1 = null;
  } else {
    tmp2_safe_receiver.fcv(['started A']);
    tmp_1 = Unit_instance;
  }
  return tmp_1;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  try {
    var tmp = $this.ldm_1.wcw('WS', retryWebsocket$o$lambda$slambda$slambda_0($this.mdm_1, $this.odm_1, $this.ldm_1, $this.pdm_1, $this.qdm_1, $this.rdm_1, $this.sdm_1, $this.tdm_1, $this.udm_1, $this.vdm_1, $this.wdm_1, $this.xdm_1, $this.ydm_1, $this.zdm_1, $this.adn_1, $this.bdn_1), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Exception()) {
      var e = $p;
      if (e instanceof CancellationException())
        return Unit_instance;
      var tmp0_safe_receiver = $this.mdm_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.fcv(['start fail: ' + e.toString()]);
      }
      printStackTrace2(e);
    } else {
      throw $p;
    }
  }
  finally {
    $this.ndm_1._v = false;
  }
  return Unit_instance;
}
var retryWebsocket$o$lambda$slambda$slambdaClass;
function retryWebsocket$o$lambda$slambda$slambda() {
  if (retryWebsocket$o$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($log, $currentWebSocket, $gate, $instanceCount, $currentWebSocketId, $underlyingSocket, $onOpenList, $lastPong, $onMessageList, $onBinaryMessageList, $onCloseList, $lastConnect, $connected, $pingTime, $currentDelay, $baseDelay) {
        this.vdl_1 = $log;
        this.wdl_1 = $currentWebSocket;
        this.xdl_1 = $gate;
        this.ydl_1 = $instanceCount;
        this.zdl_1 = $currentWebSocketId;
        this.adm_1 = $underlyingSocket;
        this.bdm_1 = $onOpenList;
        this.cdm_1 = $lastPong;
        this.ddm_1 = $onMessageList;
        this.edm_1 = $onBinaryMessageList;
        this.fdm_1 = $onCloseList;
        this.gdm_1 = $lastConnect;
        this.hdm_1 = $connected;
        this.idm_1 = $pingTime;
        this.jdm_1 = $currentDelay;
        this.kdm_1 = $baseDelay;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    retryWebsocket$o$lambda$slambda$slambdaClass = $;
  }
  return retryWebsocket$o$lambda$slambda$slambdaClass;
}
function retryWebsocket$o$lambda$slambda$slambda_0($log, $currentWebSocket, $gate, $instanceCount, $currentWebSocketId, $underlyingSocket, $onOpenList, $lastPong, $onMessageList, $onBinaryMessageList, $onCloseList, $lastConnect, $connected, $pingTime, $currentDelay, $baseDelay) {
  var i = new (retryWebsocket$o$lambda$slambda$slambda())($log, $currentWebSocket, $gate, $instanceCount, $currentWebSocketId, $underlyingSocket, $onOpenList, $lastPong, $onMessageList, $onBinaryMessageList, $onCloseList, $lastConnect, $connected, $pingTime, $currentDelay, $baseDelay);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var retryWebsocket$o$lambda$slambdaClass;
function retryWebsocket$o$lambda$slambda() {
  if (retryWebsocket$o$lambda$slambdaClass === VOID) {
    class $ {
      constructor($gate, $log, $starting, $currentWebSocket, $instanceCount, $currentWebSocketId, $underlyingSocket, $onOpenList, $lastPong, $onMessageList, $onBinaryMessageList, $onCloseList, $lastConnect, $connected, $pingTime, $currentDelay, $baseDelay) {
        this.ldm_1 = $gate;
        this.mdm_1 = $log;
        this.ndm_1 = $starting;
        this.odm_1 = $currentWebSocket;
        this.pdm_1 = $instanceCount;
        this.qdm_1 = $currentWebSocketId;
        this.rdm_1 = $underlyingSocket;
        this.sdm_1 = $onOpenList;
        this.tdm_1 = $lastPong;
        this.udm_1 = $onMessageList;
        this.vdm_1 = $onBinaryMessageList;
        this.wdm_1 = $onCloseList;
        this.xdm_1 = $lastConnect;
        this.ydm_1 = $connected;
        this.zdm_1 = $pingTime;
        this.adn_1 = $currentDelay;
        this.bdn_1 = $baseDelay;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    retryWebsocket$o$lambda$slambdaClass = $;
  }
  return retryWebsocket$o$lambda$slambdaClass;
}
function retryWebsocket$o$lambda$slambda_0($gate, $log, $starting, $currentWebSocket, $instanceCount, $currentWebSocketId, $underlyingSocket, $onOpenList, $lastPong, $onMessageList, $onBinaryMessageList, $onCloseList, $lastConnect, $connected, $pingTime, $currentDelay, $baseDelay) {
  var i = new (retryWebsocket$o$lambda$slambda())($gate, $log, $starting, $currentWebSocket, $instanceCount, $currentWebSocketId, $underlyingSocket, $onOpenList, $lastPong, $onMessageList, $onBinaryMessageList, $onCloseList, $lastConnect, $connected, $pingTime, $currentDelay, $baseDelay);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var retryWebsocket$1Class;
function retryWebsocket$1() {
  if (retryWebsocket$1Class === VOID) {
    class $ {
      constructor($connected, $currentWebSocket, $gate, $log, $instanceCount, $currentWebSocketId, $underlyingSocket, $onOpenList, $lastPong, $onMessageList, $onBinaryMessageList, $onCloseList, $lastConnect, $pingTime, $currentDelay, $baseDelay) {
        this.fdn_1 = $connected;
        this.gdn_1 = $currentWebSocket;
        this.hdn_1 = $log;
        this.idn_1 = $currentWebSocketId;
        this.jdn_1 = $onOpenList;
        this.kdn_1 = $onMessageList;
        this.ldn_1 = $onBinaryMessageList;
        this.mdn_1 = $onCloseList;
        this.cdn_1 = 0;
        this.ddn_1 = Signal().fak(false);
        this.edn_1 = SupervisorJob();
        var starting = {_v: false};
        reactiveScope(this, ($this$reactiveScope) => {
          var shouldBeOn = $this$reactiveScope.baj(this.ddn_1);
          var isOn = $this$reactiveScope.baj($connected);
          var tmp;
          if (shouldBeOn && !isOn && !starting._v) {
            starting._v = true;
            launch($this$reactiveScope, VOID, VOID, retryWebsocket$o$lambda$slambda_0($gate, $log, starting, $currentWebSocket, $instanceCount, $currentWebSocketId, $underlyingSocket, $onOpenList, $lastPong, $onMessageList, $onBinaryMessageList, $onCloseList, $lastConnect, $connected, $pingTime, $currentDelay, $baseDelay));
            tmp = Unit_instance;
          } else if (!shouldBeOn && isOn) {
            var tmp0_safe_receiver = $currentWebSocket._v;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.ndn(1000, 'OK');
            }
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
      }
      odn() {
        return this.fdn_1;
      }
      iaj() {
        var _unary__edvuaz = this.cdn_1;
        this.cdn_1 = _unary__edvuaz + 1 | 0;
        if (_unary__edvuaz === 0) {
          this.ddn_1.mam(true);
        }
        return () => {
          var tmp;
          this.cdn_1 = this.cdn_1 - 1 | 0;
          if (this.cdn_1 === 0) {
            this.ddn_1.mam(false);
            tmp = Unit_instance;
          }
          return Unit_instance;
        };
      }
      ea2() {
        return this.edn_1;
      }
      ndn(code, reason) {
        var tmp0_safe_receiver = this.hdn_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.fcv(['close ' + code]);
        }
        var tmp1_safe_receiver = this.gdn_1._v;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.ndn(code, reason);
        }
        this.gdn_1._v = null;
        this.idn_1._v = -1;
      }
      pdn(data) {
        var tmp0_safe_receiver = this.hdn_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.fcv(['' + this.idn_1._v + ' send ' + data]);
        }
        var tmp1_safe_receiver = this.gdn_1._v;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.pdn(data);
        }
      }
      qdn(data) {
        return this.pdn((!(data == null) ? typeof data === 'string' : false) ? data : THROW_CCE());
      }
      rdl(action) {
        this.jdn_1.v(action);
      }
      tdl(action) {
        this.kdn_1.v(action);
      }
      rdn(action) {
        return this.tdl(action);
      }
      udl(action) {
        this.ldn_1.v(action);
      }
      sdl(action) {
        this.mdn_1.v(action);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [CoroutineScope()]);
    retryWebsocket$1Class = $;
  }
  return retryWebsocket$1Class;
}
var typed$1Class;
function typed$1() {
  if (typed$1Class === VOID) {
    class $ {
      constructor($this_typed, $json, $receive, $send) {
        this.sdn_1 = $this_typed;
        this.tdn_1 = $json;
        this.udn_1 = $receive;
        this.vdn_1 = $send;
      }
      odn() {
        return this.sdn_1.odn();
      }
      iaj() {
        return this.sdn_1.iaj();
      }
      rdl(action) {
        return this.sdn_1.rdl(action);
      }
      sdl(action) {
        return this.sdn_1.sdl(action);
      }
      rdn(action) {
        this.sdn_1.tdl((it) => {
          var tmp;
          try {
            tmp = action(this.tdn_1.y27(this.udn_1, it));
          } catch ($p) {
            var tmp_0;
            if ($p instanceof CancellationException()) {
              var e = $p;
              tmp_0 = Unit_instance;
            } else {
              if ($p instanceof Exception()) {
                var e_0 = $p;
                report(Exception().vd('Failed to decode message; expected a ' + this.udn_1.az().h10() + " but got '" + take(it, 150) + "'", e_0));
                tmp_0 = Unit_instance;
              } else {
                throw $p;
              }
            }
            tmp = tmp_0;
          }
          return Unit_instance;
        });
      }
      qdn(data) {
        this.sdn_1.pdn(this.tdn_1.x27(this.vdn_1, data));
      }
    }
    initMetadataForClass($);
    typed$1Class = $;
  }
  return typed$1Class;
}
function *_generator_invoke__zhh2q8_1($this, it, $completion) {
  var tmp = delay(it, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var waitUntilConnect$slambdaClass;
function waitUntilConnect$slambda() {
  if (waitUntilConnect$slambdaClass === VOID) {
    class $ {
      ccx(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.ccx((!(p1 == null) ? typeof p1 === 'bigint' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    waitUntilConnect$slambdaClass = $;
  }
  return waitUntilConnect$slambdaClass;
}
function waitUntilConnect$slambda_0() {
  var i = new (waitUntilConnect$slambda())();
  var l = (it, $completion) => i.ccx(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$launch, $completion) {
  var tmp = $this.wdn_1(100n, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!$this.xdn_1._v) {
    $this.xdn_1._v = true;
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $this.ydn_1;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    this_0.rc(tmp$ret$0);
  }
  return Unit_instance;
}
var waitUntilConnect$lambda$slambdaClass;
function waitUntilConnect$lambda$slambda() {
  if (waitUntilConnect$lambda$slambdaClass === VOID) {
    class $ {
      constructor($delay, $alreadyResumed, $it) {
        this.wdn_1 = $delay;
        this.xdn_1 = $alreadyResumed;
        this.ydn_1 = $it;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    waitUntilConnect$lambda$slambdaClass = $;
  }
  return waitUntilConnect$lambda$slambdaClass;
}
function waitUntilConnect$lambda$slambda_0($delay, $alreadyResumed, $it) {
  var i = new (waitUntilConnect$lambda$slambda())($delay, $alreadyResumed, $it);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $this$launch, $completion) {
  while (true) {
    var tmp = delay($this.zdn_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var now = clockMillis();
    var tmp_0 = $this.ado_1._v;
    // Inline function 'kotlin.Long.times' call
    var this_0 = $this.zdn_1;
    var tmp$ret$0 = multiply(this_0, fromInt(3));
    if (tmp_0 < now - toNumber(tmp$ret$0)) {
      $this.bdo_1.ndn(3000, 'Server did not respond to three consecutive pings.');
    } else {
      var tmp_1 = $this.ado_1._v;
      // Inline function 'kotlin.Long.times' call
      var this_1 = $this.zdn_1;
      if (tmp_1 < now - toNumber(this_1) * 0.8) {
        $this.bdo_1.pdn(' ');
      }
    }
  }
  return Unit_instance;
}
var retryWebsocket$reset$lambda$slambdaClass;
function retryWebsocket$reset$lambda$slambda() {
  if (retryWebsocket$reset$lambda$slambdaClass === VOID) {
    class $ {
      constructor($pingTime, $lastPong, $socket) {
        this.zdn_1 = $pingTime;
        this.ado_1 = $lastPong;
        this.bdo_1 = $socket;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    retryWebsocket$reset$lambda$slambdaClass = $;
  }
  return retryWebsocket$reset$lambda$slambdaClass;
}
function retryWebsocket$reset$lambda$slambda_0($pingTime, $lastPong, $socket) {
  var i = new (retryWebsocket$reset$lambda$slambda())($pingTime, $lastPong, $socket);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  retryWebsocket as retryWebsocket1x6ytgxxp3whc,
  typed as typed3v04bxztitnhl,
};
//endregion

//# sourceMappingURL=wsretry.mjs.map
